"use strict";
/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
Object.defineProperty(exports, "__esModule", { value: true });
exports.DeferLiquidityCheckAdapterStorageV1Factory = void 0;
const ethers_1 = require("ethers");
const _abi = [
    {
        inputs: [],
        name: "WETH",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        name: "erc20TokenToTTokenMap",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        name: "oracles",
        outputs: [
            {
                internalType: "contract IPriceOracle",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "vvs",
        outputs: [
            {
                internalType: "contract IVVSRouter02",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
];
const _bytecode = "0x608060405234801561001057600080fd5b50610195806100206000396000f3fe608060405234801561001057600080fd5b506004361061004c5760003560e01c806308e77344146100515780638a70e43914610080578063ad5c4648146100b4578063addd5099146100c7575b600080fd5b600154610064906001600160a01b031681565b6040516001600160a01b03909116815260200160405180910390f35b61006461008e36600461012d565b60036020908152600092835260408084209091529082529020546001600160a01b031681565b600054610064906001600160a01b031681565b6100646100d536600461010c565b6002602052600090815260409020546001600160a01b031681565b80356001600160a01b038116811461010757600080fd5b919050565b60006020828403121561011d578081fd5b610126826100f0565b9392505050565b6000806040838503121561013f578081fd5b610148836100f0565b9150610156602084016100f0565b9050925092905056fea2646970667358221220370ba85814641bd63e20126d64868b53b7ef1a03eaa2ddd2a1b29b4c27f7c44b64736f6c63430008030033";
class DeferLiquidityCheckAdapterStorageV1Factory extends ethers_1.ContractFactory {
    constructor(...args) {
        if (args.length === 1) {
            super(_abi, _bytecode, args[0]);
        }
        else {
            super(...args);
        }
    }
    deploy(overrides) {
        return super.deploy(overrides || {});
    }
    getDeployTransaction(overrides) {
        return super.getDeployTransaction(overrides || {});
    }
    attach(address) {
        return super.attach(address);
    }
    connect(signer) {
        return super.connect(signer);
    }
    static createInterface() {
        return new ethers_1.utils.Interface(_abi);
    }
    static connect(address, signerOrProvider) {
        return new ethers_1.Contract(address, _abi, signerOrProvider);
    }
}
exports.DeferLiquidityCheckAdapterStorageV1Factory = DeferLiquidityCheckAdapterStorageV1Factory;
DeferLiquidityCheckAdapterStorageV1Factory.bytecode = _bytecode;
DeferLiquidityCheckAdapterStorageV1Factory.abi = _abi;
//# sourceMappingURL=DeferLiquidityCheckAdapterStorageV1Factory.js.map